import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/rfb`;

export const consultaCPF = (cpf) => {
	const url = `${BASE_URL}/buscar-dados/${cpf}`;
	return api.get(url);
};
